export function fadeInElements() {
  // Delay between staggered elements in milliseconds
  const STAGGER_DELAY = 0;
  
  // Global counter for all observed elements
  let itemCount = 0;
  
  const observer = new IntersectionObserver(
    (entries) => {
      // First, check if this is a single element
      if (entries.length === 1) {
        // For a single element, no delay
        const entry = entries[0];
        if (entry.isIntersecting) {
          entry.target.dataset.animate = "visible";
          observer.unobserve(entry.target);
        }
        return;
      }
      
      // For multiple elements, apply staggered delays
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          
          setTimeout(() => {
            element.dataset.animate = "visible";
          }, itemCount * STAGGER_DELAY);
          
          itemCount++;
          observer.unobserve(element);
        }
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -100px 0px"
    }
  );

  const fadeElements = document.querySelectorAll('[data-animate="fadein"]:not(.skip)');
  
  if (fadeElements.length > 0) {
    fadeElements.forEach(element => observer.observe(element));
  }
}

//import ScrollReveal from 'scrollreveal';

//   const sr = ScrollReveal();

//   sr.reveal('[data-animate="fadein"]:not(.skip)', {
//     duration: 400, 
//     distance: '20px', 
//     easing: 'cubic-bezier(0.4,0,0.2,1)',
//     interval: 100, 
//     viewOffset: { top: 0, right: 0, bottom: 100, left: 0 }, 
//     reset: false 
//   });

//   sr.reveal('[data-animate="slidein"]:not(.skip)', {
//     duration: 500,
//     distance: '30px',
//     easing: 'ease-in-out',
//     interval: 150,
//     viewOffset: { top: 0, right: 0, bottom: 100, left: 0 },
//     reset: false
//   });
// }

// Fadein elements
// https://dev.to/jslim/fading-up-sections-using-intersection-observer-3fhj

// import { gsap } from "gsap";

// export function fadeInElements() {

//   const observerOptions = {
//     root: null,
//     threshold: 0,
//     rootMargin: '0px 0px -100px 0px'
//   };

//   let itemLoad = 0;
//   const itemDelay = 0.1;

//   const observer = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           gsap.to( entry.target, { duration: 0.5, opacity: 1, x: 0, y: 0, delay: itemLoad*itemDelay } );
//           itemLoad++;
//           observer.unobserve(entry.target);
//         }
//     });
//   }, observerOptions);

//   const fadeElements = document.querySelectorAll('[data-animate="fadein"]:not(.skip)');

//   if (fadeElements.length > 0) {
//     fadeElements.forEach(function(element) {
//       observer.observe(element);
//     });
//   }

// }


  // Fadein text on load
  // const contentElements = document.getElementsByClassName("component");

  // if (contentElements.length) {
  //   setTimeout(() => {
  //     Array.from(contentElements).forEach(element => element.classList.add("show"));
  //   }, 100);
  // }

  // Observeer alle elementen met de class 'fadeup'
  // document.querySelectorAll('.fadeup:not(.skip)').forEach(function(element) {
  //   observer.observe(element);
  // });

